/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AccessTokenType } from './';
import {
    AccessTokenTypeFromJSON,
    AccessTokenTypeFromJSONTyped,
    AccessTokenTypeToJSON,
} from './';
import type { TokenPermissionResource } from './';
import {
    TokenPermissionResourceFromJSON,
    TokenPermissionResourceFromJSONTyped,
    TokenPermissionResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface AccessTokenResource
 */
export interface AccessTokenResource {
    /**
     * 
     * @type {string}
     * @memberof AccessTokenResource
     */
    id: string;
    /**
     * 
     * @type {AccessTokenType}
     * @memberof AccessTokenResource
     */
    type: AccessTokenType;
    /**
     * 
     * @type {string}
     * @memberof AccessTokenResource
     */
    entityId: string;
    /**
     * 
     * @type {string}
     * @memberof AccessTokenResource
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AccessTokenResource
     */
    hint: string;
    /**
     * 
     * @type {string}
     * @memberof AccessTokenResource
     */
    note?: string;
    /**
     * 
     * @type {Date}
     * @memberof AccessTokenResource
     */
    creationDate: Date;
    /**
     * 
     * @type {Array<TokenPermissionResource>}
     * @memberof AccessTokenResource
     */
    permissions: Array<TokenPermissionResource>;
}

/**
 * Check if a given object implements the AccessTokenResource interface.
 */
export function instanceOfAccessTokenResource(value: object): value is AccessTokenResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('entityId' in value) || value['entityId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('hint' in value) || value['hint'] === undefined) return false;
    if (!('creationDate' in value) || value['creationDate'] === undefined) return false;
    if (!('permissions' in value) || value['permissions'] === undefined) return false;
    return true;
}

export function AccessTokenResourceFromJSON(json: any): AccessTokenResource {
    return AccessTokenResourceFromJSONTyped(json, false);
}

export function AccessTokenResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessTokenResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': AccessTokenTypeFromJSON(json['type']),
        'entityId': json['entityId'],
        'name': json['name'],
        'hint': json['hint'],
        'note': json['note'] == null ? undefined : json['note'],
        'creationDate': (new Date(json['creationDate'])),
        'permissions': ((json['permissions'] as Array<any>).map(TokenPermissionResourceFromJSON)),
    };
}

export function AccessTokenResourceToJSON(value?: AccessTokenResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'type': AccessTokenTypeToJSON(value['type']),
        'entityId': value['entityId'],
        'name': value['name'],
        'hint': value['hint'],
        'note': value['note'],
        'creationDate': ((value['creationDate']).toISOString()),
        'permissions': ((value['permissions'] as Array<any>).map((v) => TokenPermissionResourceToJSON(v))),
    };
}

